<template>
  <div :class="prefixCls">
    <div v-if="sl" :class="prefixCls + '-con'">
      <slot></slot>
    </div>
    <div v-else :class="prefixCls + '-con'">
      <span>
        <img src="https://chain-apply.oss-cn-shanghai.aliyuncs.com/pack/empty.png" alt="">
      </span>
      <!-- <i :class="'iconfont' + ' ' + icon"></i> -->
      <p>{{txt}}</p>
    </div>
  </div>
</template>

<script>
const prefixCls = "zEmpty";
export default {
  name: "ZEmty",
  data() {
    return {
      prefixCls: prefixCls
    };
  },
  props: {
    icon: {
      type: String,
      default: "icon-wuneirong1"
    },
    txt: {
      type: String,
      default: "暂时没有内容哦！"
    },
    sl: {
      type: Boolean,
      default: false
    }
  }
};
</script>

